import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormatObjService {
  // tslint:disable: prefer-const
  // Le da formato (saca del array a elementos que no son array) al objeto para comparación (proveedores y users)
  formatObjProv(objc) {
    let ret: any = {};
    for (let i in objc) {
      if (typeof objc[i] === 'string' && objc[i] !== '') {
        ret[i] = objc[i];
      } else if (typeof objc[i] === 'number' && objc[i] !== null) {
        ret[i] = objc[i];
      } else if (objc[i] === null) {
      } else if (objc[i] === objc['MailPago']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['prnt']) {
        ret[i] = objc[i];
      } else {
        ret[i] = objc[i][0];
      }
    }
    return ret;
  }

  // Format OC object
  formatObjOc(objc) {
    let ret: any = {};
    for (let i in objc) {
      if (typeof objc[i] === 'string' && objc[i] !== '') {
        ret[i] = objc[i];
      } else if (typeof objc[i] === 'number' && objc[i] !== null) {
        ret[i] = objc[i];
      } else if (objc[i] === null) {
      } else if (objc[i] === objc['imputacion']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['resolucion']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['fr']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['cdp']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['email']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['FechaEnvio']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      }else if (objc[i] === objc['docReq']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['hitox']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else {
        ret[i] = objc[i][0];
      }
    }

    return ret;
  }

  // format documentos (Módulo docu y contra)
  formatObjDoc(objc) {
    let ret: any = {};
    for (let i in objc) {
      if (typeof objc[i] === 'string' && objc[i] !== '') {
        ret[i] = objc[i];
      } else if (typeof objc[i] === 'number' && objc[i] !== null) {
        ret[i] = objc[i];
      } else if (objc[i] === null) {
      } else if (objc[i] === objc['tble_item']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['item']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['notas']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['tble_prov']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['tble_file']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['docReqList']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['question']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['userFull']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['hitox']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['devolucion']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['ccEmailx']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else {
        ret[i] = objc[i][0];
      }
    }
    return ret;
  }

  // Format Solicitud de Pago
  formatObjSolpag(objc) {
    let ret: any = {};
    for (let i in objc) {
      if (typeof objc[i] === 'string' && objc[i] !== '') {
        ret[i] = objc[i];
      } else if (typeof objc[i] === 'number' && objc[i] !== null) {
        ret[i] = objc[i];
      } else if (objc[i] === null) {
      } else if (objc[i] === objc['documentos']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['documentosNumero']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['oc']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['resol']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['proveedor']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['prnt']) {
        ret[i] = objc[i];
      } else if (objc[i] === objc['tble_prov']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['tble_docu']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['imputacion']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['fr']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['cdp']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['FechaEnvio']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['fechaDespa']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['prod']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else {
        ret[i] = objc[i][0];
      }
    }

    return ret;
  }

  // Format Solicitud pago finanzas
  formatObjSolpagFin(objc) {
    let ret: any = {};
    for (let i in objc) {
      if (typeof objc[i] === 'string' && objc[i] !== '') {
        ret[i] = objc[i];
      } else if (typeof objc[i] === 'number' && objc[i] !== null) {
        ret[i] = objc[i];
      } else if (objc[i] === objc['emailPago']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['emailPagoCC']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['tble_file']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === null) {
      } else {
        ret[i] = objc[i][0];
      }
    }
    return ret;
  }

  // Dar formato al objeto para ser enviado al servicio de borrado (proveedores)
  formatSolComp(objc) {
    let ret: any = {};
    for (let i in objc) {
      if (typeof objc[i] === 'string' && objc[i] !== '') {
        ret[i] = objc[i];
      } else if (typeof objc[i] === 'number' && objc[i] !== null) {
        ret[i] = objc[i];
      } else if (objc[i] === null) {
      } else if (objc[i] === objc['MailPago']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['prnt']) {
        ret[i] = objc[i];
      } else if (objc[i] === objc['unidadReqUser']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['contrTec']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['analisComp']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['jefDepComp']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['autorizacion']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['adminGen']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else if (objc[i] === objc['depFin']) {
        ret[i] = JSON.parse(JSON.stringify(objc[i]));
      } else {
        ret[i] = objc[i][0];
      }
    }
    return ret;
  }

  formatObjInic(atrb) {
    let ret: any = {};
    for (let i in atrb) {
      if (typeof atrb[i] === 'string' && atrb[i] !== '') {
        ret[i] = atrb[i];
      } else if (typeof atrb[i] === 'number' && atrb[i] !== null) {
        ret[i] = atrb[i];
      } else if (atrb[i] === null) {
        // Manejo de la respuesta del null
      } else if (atrb[i] === atrb['obsJddc']) {
        ret[i] = JSON.parse(JSON.stringify(atrb[i]));
      } else if (atrb[i] === atrb['obsJf']) {
        ret[i] = JSON.parse(JSON.stringify(atrb[i]));
      } else if (atrb[i] === atrb['obsJDAG']) {
        ret[i] = JSON.parse(JSON.stringify(atrb[i]));
      } else if (atrb[i] === atrb['impu']) {
        ret[i] = JSON.parse(JSON.stringify(atrb[i]));
      } else {
        ret[i] = atrb[i][0];
      }
    }
    return ret;
  }

  // Comparar la data actual registrada con la actualizada
  compareJSON(obj1, obj2) {
    let ret: any = {};

    // Validación solo en prove
    if (obj2.Region == undefined) {
    } else if (typeof obj2.Region === 'object') {
      obj2.Nombre = obj2.Region.region;
    }

    if (obj1.prnt !== undefined) {
      delete obj1.prnt;
    }
    if (obj2.prnt !== undefined) {
      delete obj2.prnt;
    }
    for (let i in obj2) {
      if (!obj1.hasOwnProperty(i) || JSON.stringify(obj2[i]) !== JSON.stringify(obj1[i])) {
        ret[i] = obj2[i];
      }
    }
    return ret;
  }

  // Comparar la data del objeto a actulizar para determinar que se debe borrar
  compareJSONBorrar(obj1, obj2) {
    let ret: any = {};
    if (obj1.prnt !== undefined) {
      delete obj1.prnt;
    }
    if (obj2.prnt !== undefined) {
      delete obj2.prnt;
    }
    for (let i in obj2) {
      if (obj1.hasOwnProperty(i)) {
        ret[i] = obj2[i];
      }
    }
    return ret;
  }
}
